import * as Sentry from "@sentry/nextjs"
import styles from "./SentryErrorBoundary.module.css"

/**
 * Fallback UI displayed when a React render error is caught.
 * The error is automatically captured by Sentry via the ErrorBoundary wrapper.
 */
function SentryFallback({ error, resetError }) {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>⚠️</div>
      <h2 className={styles.title}>Đã xảy ra lỗi</h2>
      <p className={styles.message}>Chúng tôi đã ghi nhận sự cố và đang xử lý. Vui lòng thử lại.</p>
      <button className={styles.button} onClick={resetError}>
        Thử lại
      </button>
    </div>
  )
}

/**
 * Wraps children with Sentry's ErrorBoundary.
 * Any uncaught render error will be:
 *   1. Captured and sent to Sentry automatically
 *   2. Displayed as a friendly fallback UI instead of a blank/crashed page
 *
 * @example
 * <SentryErrorBoundary>
 *   <MyComponent />
 * </SentryErrorBoundary>
 */
export default function SentryErrorBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary fallback={(props) => <SentryFallback {...props} />} showDialog={false}>
      {children}
    </Sentry.ErrorBoundary>
  )
}
